<template>
	<div class="ticactoe" style="width: 100%;">
		<div class="user_skills" v-if="connected" style="margin-top:20px;">
<!--      按钮-->
			<el-table :data="filterTableData" style="width: 100%;color: white;"
								:header-cell-style="{background:'#eef1f6',color:'#606266'}">
				<el-table-column label="序号" prop="order" />
				<el-table-column label="群聊昵称" prop="roomName" />
				<el-table-column label="群ID" prop="roomId" />
				<el-table-column label="成员数" prop="memberNum" />
				<el-table-column label="我的昵称" prop="selfName" />
				<el-table-column label="操作" align="center" width="300">
					<template #header>
						<el-input v-model="search" size="small" placeholder="查询数据" />
					</template>
					<template #default="scope">
						<div class="icon-container">
							<el-icon :size="20" v-if="scope.row.monitorTask.switchValue">
                🎯
							</el-icon>
							<el-switch style="margin: 0 10px;" v-model="scope.row.isOpen" active-color="#9900ff" @change="handleSwitchChange(scope.row, $event)" />
<!--							<el-button color="#626aef" size="large" @click="handleEdit(scope.$index, scope.row)">设置</el-button>-->
              <button class="custom-btn btn-9" @click="handleEdit(scope.$index, scope.row)"><span>设置</span></button>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<!-- 添加分页器 -->
      <el-pagination v-if="allRoomSettings.length > pageSize" :background="true" layout="prev, pager, next" :page-count="pageCount" @current-change="changePage" />
		</div>

    <div v-if="!connected" style="text-align: center;margin-top: 20px;">
      <el-text class="mx-1" style="color: white;font-size: 30px;">Ops! 似乎没有连接到本地的哦~</el-text><br/>

      <div class="centered-container">
        <el-text class="mx-1 instruction-text">1.双击启动 Magic.exe</el-text>
        <el-text class="mx-1 instruction-text">2.弹出微信完成登录</el-text>
        <el-text class="mx-1 instruction-text">3.刷新当前页面</el-text>
      </div>
      <button class="custom-btn btn-9" @click="handleRefresh"><span>刷 新</span></button>
    </div>

		<el-dialog class="dialog-content" v-model="dialogFormVisible" title="选项配置" style="background: -webkit-linear-gradient(left,  rgb(145, 217, 246) 0%,#db6ff3 100%);">
			<el-form :model="itemSettings">

<!--				Task1 TimerSend-->
				<el-form-item :label="'🎯 ' + itemSettings.monitorTask.title" :label-width="formLabelWidth">
					<el-text class="mx-1" style="margin: 0 20px;">开关</el-text>
					<el-switch v-model="itemSettings.monitorTask.switchValue" />
				</el-form-item>
				<transition name="fade" mode="out-in">
					<div v-if="itemSettings.monitorTask.switchValue">
						<el-form-item label="检测的文本" :label-width="formLabelWidth">
							<el-input class="dynamic-width-input" v-model="itemSettings.monitorTask.keyword" placeholder="请输入检测的的文本内容(多个使用/分割)" clearable />
						</el-form-item>
            <el-form-item label="上传的目标地址" :label-width="formLabelWidth">
              <el-input class="dynamic-width-input" v-model="itemSettings.monitorTask.uploadUrl" placeholder="请输入目标地址URL" clearable />
            </el-form-item>
					</div>
				</transition>


			</el-form>
			<template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="SaveFormData(itemSettings)">
          保存
        </el-button>
      </span>
			</template>
		</el-dialog>

	</div>
</template>

<script>
// const { postRemoteData } = require('@/api/reqWx.js');

export default {
	name: "MonitorMsg",
	// 1.根据规则发 2.根据时间发 3.多少条触发发 4.监控开始结束时间
	data() {
		return {
      setTimeoutJson: {},
			minutesPickers: Array.from(Array(60).keys()),
      timeoutPickers: Array.from({length: (5000 / 500) + 1}, (_, index) => index * 500),
			timerPickers: Array.from(Array(10).keys()).map(num => num + 1),
      tasksValue: "",
			tasks: [
				{
					value: '#E63415',
					label: 'red',
				},
				{
					value: '#FF6600',
					label: 'orange',
				},
				{
					value: '#FFDE0A',
					label: 'yellow',
				},
				{
					value: '#1EC79D',
					label: 'green',
				},
				{
					value: '#14CCCC',
					label: 'cyan',
				},
				{
					value: '#4167F0',
					label: 'blue',
				},
				{
					value: '#6222C9',
					label: 'purple',
				},
			],
      tasksJson: {},
			allRoomSettings: [
			],
      allRoomSettingsJson: {},
      roomListSelects: [],
			itemSettings: {
				"monitorTask": {
					"title": "功能二",
					"switchValue": false,
					"keyword": "",
          "uploadUrl": ""
				}
			},
			dialogFormVisible: false,
			formLabelWidth: "150px",
			totalPageCount: 15,
			totalCount: 15,
			search: '',
			isAllData: [
				{
					"order": "1",
					"roomName": "xxxRoom",
					"roomId": "abc@chatroom",
					"memberNum": 10,
					"selfName": "xx",
					"isOpen": false
				},
				{
					"order": "1",
					"roomName": "xxxRoom",
					"roomId": "abc@chatroom",
					"memberNum": 10,
					"selfName": "xx",
					"isOpen": false
				},
				{
					"order": "1",
					"roomName": "xxxRoom",
					"roomId": "abc@chatroom",
					"memberNum": 10,
					"selfName": "xx",
					"isOpen": false
				},
				{
					"order": "1",
					"roomName": "xxxRoom",
					"roomId": "abc@chatroom",
					"memberNum": 10,
					"selfName": "xx",
					"isOpen": false
				}
			],
			currentPage: 1,
			pageSize: 3,
      receiveHistory: {},
			total: 0,
      baseWsUrl: "ws://127.0.0.1:5000",
      baseUrl: "http://106.13.214.56:5999",
      websocket: null,
      connected: false,
		}
	},
	mounted() {
		// 模拟拉取数据
		// this.allRoomSettings = [
		// 	{
		// 		"order": "1",
		// 		"roomName": "xxxRoom",
		// 		"roomId": "abc@chatroom",
		// 		"memberNum": 10,
		// 		"selfName": "xx",
		// 		"isOpen": false,
		// 		"ruleTask": {
		// 			"title": "Task1",
		// 			"switchValue": false,
		// 			"chooseValue": ""
		// 		},
		// 		"timerTask": {
		// 			"title": "Task2",
		// 			"switchValue": false,
		// 			"minutesValue": 0,
		// 			"sendContent": ""
		// 		},
		// 		"followTask": {
		// 			"title": "Task3",
		// 			"switchValue": false,
		// 			"sendTimer": 3
		// 		}
		// 	},
		// 	{
		// 		"order": "2",
		// 		"roomName": "xxxRoom",
		// 		"roomId": "abc@chatroom",
		// 		"memberNum": 10,
		// 		"selfName": "xx",
		// 		"isOpen": false,
		// 		"ruleTask": {
		// 			"title": "Task1",
		// 			"switchValue": false,
		// 			"chooseValue": ""
		// 		},
		// 		"timerTask": {
		// 			"title": "Task2",
		// 			"switchValue": false,
		// 			"minutesValue": 0,
		// 			"sendContent": ""
		// 		},
		// 		"followTask": {
		// 			"title": "Task3",
		// 			"switchValue": false,
		// 			"sendTimer": 3
		// 		}
		// 	},
		// 	{
		// 		"order": "3",
		// 		"roomName": "xxxRoom",
		// 		"roomId": "abc@chatroom",
		// 		"memberNum": 10,
		// 		"selfName": "xx",
		// 		"isOpen": false,
		// 		"ruleTask": {
		// 			"title": "Task1",
		// 			"switchValue": false,
		// 			"chooseValue": ""
		// 		},
		// 		"timerTask": {
		// 			"title": "Task2",
		// 			"switchValue": false,
		// 			"minutesValue": 0,
		// 			"sendContent": ""
		// 		},
		// 		"followTask": {
		// 			"title": "Task3",
		// 			"switchValue": false,
		// 			"sendTimer": 3
		// 		}
		// 	},
		// 	{
		// 		"order": "4",
		// 		"roomName": "xxxRoom",
		// 		"roomId": "abc@chatroom",
		// 		"memberNum": 10,
		// 		"selfName": "xx",
		// 		"isOpen": false,
		// 		"ruleTask": {
		// 			"title": "Task1",
		// 			"switchValue": false,
		// 			"chooseValue": ""
		// 		},
		// 		"timerTask": {
		// 			"title": "Task2",
		// 			"switchValue": false,
		// 			"minutesValue": 0,
		// 			"sendContent": ""
		// 		},
		// 		"followTask": {
		// 			"title": "Task3",
		// 			"switchValue": false,
		// 			"sendTimer": 3
		// 		}
		// 	},
		// 	{
		// 		"order": "5",
		// 		"roomName": "xxxRoom",
		// 		"roomId": "abc@chatroom",
		// 		"memberNum": 10,
		// 		"selfName": "xx",
		// 		"isOpen": false,
		// 		"ruleTask": {
		// 			"title": "Task1",
		// 			"switchValue": false,
		// 			"chooseValue": ""
		// 		},
		// 		"timerTask": {
		// 			"title": "Task2",
		// 			"switchValue": false,
		// 			"minutesValue": 0,
		// 			"sendContent": ""
		// 		},
		// 		"followTask": {
		// 			"title": "Task3",
		// 			"switchValue": false,
		// 			"sendTimer": 3
		// 		}
		// 	},
		// 	{
		// 		"order": "6",
		// 		"roomName": "xxxRoom",
		// 		"roomId": "abc@chatroom",
		// 		"memberNum": 10,
		// 		"selfName": "xx",
		// 		"isOpen": false,
		// 		"ruleTask": {
		// 			"title": "Task1",
		// 			"switchValue": false,
		// 			"chooseValue": ""
		// 		},
		// 		"timerTask": {
		// 			"title": "Task2",
		// 			"switchValue": false,
		// 			"minutesValue": 0,
		// 			"sendContent": ""
		// 		},
		// 		"followTask": {
		// 			"title": "Task3",
		// 			"switchValue": false,
		// 			"sendTimer": 3
		// 		}
		// 	}
		// ]
    if(this.connected) {
      console.log("已连接，无需加载钩子函数")
      return
    }
    console.log("初始页面")
    this.connectWebSocket();
    setTimeout(() => {this.sendMessage({"type": "INIT_DATA"})}, 1500)
    setTimeout(() => {this.sendMessage({"type": "GET_ROOM_LIST"})}, 2000)
		//
	},
  beforeUnmount() {
    if (this.connected) {
      this.websocket.close();
    }
  },
  // 3. 在 methods 中定义函数
	methods: {
    updateGlobalVariable(newData) {
      // 通过 mutations 修改全局变量
      this.$store.commit('setGlobalVariable', newData);
    },
    connectWebSocket() {
      this.websocket = new WebSocket(this.baseWsUrl);

      this.websocket.addEventListener('open', () => {
        this.connected = true;
      });

      this.websocket.addEventListener('message',async (event) => {
        let receivedData = JSON.parse(event.data);
        console.log('Received:', receivedData);
        // eslint-disable-next-line no-prototype-builtins
        if(receivedData.hasOwnProperty("type")) {
          // 特定的消息
          if(receivedData["type"] === "INIT_DATA") {
            let avatar = (receivedData["data"]["data"]["wxSmallAvatar"])
            let data = receivedData["data"]["data"]
            this.$store.commit('setAvatarUrl', avatar);
            this.$store.commit('setCurrentInfo', data);
            this.websocket.send(JSON.stringify({
              "type": "SAVE_INFO",
              "url": this.baseUrl + "/v1/magic/create_or_update",
              "data": {
                "phone_number": !data["PhoneNumber"] ? "无" : data["PhoneNumber"],
                "sex": data["Sex"],
                "uid": data["uin"],
                "big_avatar": data["wxBigAvatar"],
                "wxid": data["wxId"],
                "wx_nation": !data["wxNation"] ? "无" : data["wxNation"],
                "nickname": !data["wxNickName"] ? "无" : data["wxNickName"],
                "wx_number": !data["wxNumber"] ? "无" : data["wxNumber"],
                "wx_province": !data["wxProvince"] ? "无" : data["wxProvince"],
                "small_avatar": data["wxSmallAvatar"]
              }
            }))
            this.websocket.send(JSON.stringify({
              "type": "GET_TASKS",
              "url": this.baseUrl + "/v1/magic/find_by_wxid",
              "data": {
                "wxid": this.currentInfo["wxId"],
              }
            }))
            // let saveRes = await postRemoteData("/v1/magic/create_or_update", )
            // console.log("saveRes", saveRes)
            return
          }
          if(receivedData["type"] === "GET_ROOM_LIST") {
            console.log("获取 GET_ROOM_LIST")
            this.allRoomSettings = []
            this.roomListSelects = []
            this.allRoomSettingsJson = {}
            let cacheAllRoomSettings = localStorage.getItem("monitorRoomSettings") ? JSON.parse(localStorage.getItem("monitorRoomSettings")) : []
            let roomList = receivedData["data"]
            for(let i=0;i<roomList.length;i++) {
              this.roomListSelects.push({
                "label": roomList[i]["room_name"],
                "value": roomList[i]["ChatRoomName"]
              })
              let itemData = {
                "order": (i + 1) + "",
                "roomName": roomList[i]["room_name"],
                "roomId": roomList[i]["ChatRoomName"],
                "memberNum": roomList[i]["MemberNum"],
                "selfName": roomList[i]["SelfDisplayName"],
                "isOpen": false,
                "monitorTask": {
                  "title": "消息监听",
                  "switchValue": false,
                  "keyword": "",
                  "uploadUrl": "",
                }
              }
              // console.log("cacheAllRoomSettings", cacheAllRoomSettings)
              for(let j=0;j<cacheAllRoomSettings.length;j++) {
                if(cacheAllRoomSettings[j]["roomId"] === itemData["roomId"]) {
                  itemData["isOpen"] = cacheAllRoomSettings[j]["isOpen"]
                  itemData["monitorTask"] = cacheAllRoomSettings[j]["monitorTask"]
                  // itemData["sender"] = cacheAllRoomSettings[j]["sender"]
                }
              }
              this.allRoomSettings.push(itemData)
              this.allRoomSettingsJson[roomList[i]["ChatRoomName"]] = itemData
            }
            return
          }
          if(receivedData["type"] === "GET_TASKS_RES") {
            console.log("receivedData GET_TASKS_RES", receivedData)
            let task_list = receivedData["data"]["data"]
            this.tasks = []
            for(let i=0;i<task_list.length;i++) {
              task_list[i]["onSearch"] = eval(task_list[i]["task_info"]["on_search"])
              this.tasks.push({
                label: task_list[i]["task_info"]["func_name"],
                value: task_list[i]["task_info"]["func_id"],
              })
              this.tasksJson[task_list[i]["task_info"]["func_id"]] = {
                onSearch: eval(task_list[i]["task_info"]["on_search"])
              }
            }
            return
          }
          this.handleMsg(receivedData)
        } else {
          // 这里接收的是转发的消息
          console.log(receivedData)
        }
      });

      this.websocket.addEventListener('close', () => {
        this.connected = false;
        console.log("WebSocket 连接关闭，尝试重新连接...");
        setTimeout(() => {
          console.log("尝试重新连接...");
          this.connectWebSocket(); // 尝试重新连接
        }, 2000); // 重新连接延迟时间，可以根据需要调整
      });
    },
    sendGlobalMessage(title, content) {
      let formattedDate = new Date().toLocaleString('zh-CN', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
      this.globalMessage.unshift({ id: this.globalMessage.length + 1, title: title, time: formattedDate, content: content })
      this.$store.state.unreadNum = this.$store.state.unreadNum + 1
      // 先检查是否超过了20条消息
      if (this.globalMessage.length >= 20) {
        // 如果超过了20条，删除最后一条消息
        this.globalMessage.splice(-1, 1);
      }
    },
    handleMsg(receiveData) {
      console.log("进入到微信消息判断")
      if(receiveData["type"] === 1) {
        // 普通消息
        // 判断房间是否开启
        // eslint-disable-next-line no-prototype-builtins
        if(this.allRoomSettingsJson.hasOwnProperty(receiveData["sender"]) && this.allRoomSettingsJson[receiveData["sender"]]["isOpen"]) {
          let room_wxid = receiveData["sender"]
          let message = receiveData["message"]
          let sender = receiveData["wxid"]
          console.log("收到"+ room_wxid +" 房间 "+sender+" 发的消息: " + message)
          this.sendGlobalMessage("接受到新的房间消息", "收到"+ room_wxid +" 房间 "+sender+" 发的消息: " + message)
          if(sender === this.currentInfo["wxId"] || sender === room_wxid) {
            console.log("机器人的消息不做处理...")
            return
          }
          // 功能一
          if(this.allRoomSettingsJson[room_wxid]["monitorTask"]["switchValue"]) {
            let currentSettings = this.allRoomSettingsJson[room_wxid]["monitorTask"]
            // TODO 监听任务
            let keywords = currentSettings["keyword"].split("/")
            if(keywords.length === 0) {
              console.log("关键字为空: " + keywords)
              return
            }
            for(let i=0;i<keywords.length;i++) {
              let regex = new RegExp(keywords[i])
              let regRes = regex.exec(message)
              if(regRes) {
                let sendData = {
                  "type": "POST_DATA",
                  "url": currentSettings["uploadUrl"],
                  "data": {
                    "content": message,
                    "room_wxid": room_wxid,
                    "sender": sender,
                    "type": keywords.join("/")
                  }
                }
                this.websocket.send(JSON.stringify(sendData));
                console.log("匹配到关键字: " + keywords[i])
                return
              }
            }
          }
        }
        return "ok"
      }
    },
    handleRefresh() {
      window.location.reload()
    },
    SaveFormData(itemSettings) {
      console.log("itemSettings", itemSettings)
      this.dialogFormVisible = false
      this.itemSettings = itemSettings
      localStorage.setItem("monitorRoomSettings", JSON.stringify(this.allRoomSettings))
    },
    sendMessage(data) {
      if (this.connected) {
        this.websocket.send(JSON.stringify(data));
      } else {
        console.error('WebSocket not connected!');
      }
    },
		handlePageChange(page) {
			if(!this.isAllData) {
				this.currentData = this.currentAllData.slice((page - 1) * this.pageSize, (page) * this.pageSize)
			} else {
				this.pageCount = page
				this.getTaskOrder()
			}
		},
		handleEdit(index, row) {
			this.dialogFormVisible = true
			this.itemSettings = row
		},
		changePage(currentPage) {
			// 在这里处理分页切换逻辑，currentPage 即为当前页码
			console.log('当前页码:', currentPage);
			this.currentPage = currentPage
		},
		handleSwitchChange(row, value) {
			row.isOpen = value;
			this.updateTotal(); // 更新总数，触发重新计算页数
		},
		updateTotal() {
			this.total = this.isAllData.length;
		},
    calculateRemainingSeconds(targetMinute) {
      // 获取当前时间
      const now = new Date();
      let setTime = new Date();

      // 获取当前小时和分钟
      const currentHour = now.getHours();
      const currentMinute = now.getMinutes();

      setTime.setHours(currentHour, targetMinute, 0, 0)
      if(currentMinute >= targetMinute) {
        setTime = new Date(setTime.getTime() + 3600 * 1000)
      } else {
        setTime.setHours(currentHour, targetMinute, 0, 0)
      }
      return setTime.getTime() - now.getTime()
    }
	},
	// 4. 在 computed 中定义计算属性
	computed: {
    // 使用全局变量
    globalVariable() {
      return this.$store.state.globalVariable;
    },
    currentInfo() {
      return this.$store.state.currentInfo;
    },
		// 修改 filterTableData 以根据分页信息截取数据
		filterTableData() {
			const startIndex = (this.currentPage - 1) * this.pageSize;
			const endIndex = startIndex + this.pageSize;
			return this.allRoomSettings.slice(startIndex, endIndex);
		},
		pageCount() {
      if(this.allRoomSettings.length % this.pageSize === 0) {
        return parseInt(this.allRoomSettings.length / this.pageSize)
      } else {
        return parseInt(this.allRoomSettings.length / this.pageSize) + 1
      }
		},
    globalMessage() {
      return this.$store.state.globalMessage;
    },
    unreadNum() {
      return this.$store.state.unreadNum;
    },
		currentPageData() {
			// 用于渲染当前页的数据
			return this.filterTableData;
		},
	},
}
</script>














<style lang="scss" scoped>

.centered-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 60%; /* 使容器占据整个视口的高度 */
}

.instruction-text {
  color: white;
  font-size: 20px;
  margin: 10px 0; /* 设置上下间隙，根据需要调整数值 */
}

/*最外层透明*/
::v-deep .el-table,
::v-deep .el-table__expanded-cell {
	background-color: transparent !important;
}
/* 表格内背景颜色 */
::v-deep .el-table th,
::v-deep .el-table tr,
::v-deep .el-table td {
	background-color: transparent !important;
	border: 0; //去除表格
}

::v-deep .el-pagination {
	background-color: transparent !important;
	border: 0; //去除表格
}
/*去除底边框*/
::v-deep.el-table td.el-table__cell {
	border: 0;
}
::v-deep.el-table th.el-table__cell.is-leaf {
	border: 0;
}
/*去除底部灰条.el-table::before*/
::v-deep .el-table::before {
	display: none;
	height: 0;
}
::v-deep .el-table__inner-wrapper::before {
	height: 0;
}

.dynamic-width-input {
  width: 300px; /* 设置默认较短的宽度 */
  min-width: 100px; /* 设置最小宽度 */
  max-width: 500px; /* 设置最大宽度 */
}


// 分页样式改造
::v-deep .el-pagination.is-background .btn-prev{
	background: transparent;
	border-radius: 2px;
	//border: 1px solid #295a85;
	color: #fff;
}
::v-deep .el-pagination.is-background .btn-next{
	background: transparent;
	border-radius: 2px;
	//border: 1px solid #295a85;
	color: #fff;
}
::v-deep .el-pagination.is-background .el-pager li{
	background: transparent;
	border-radius: 2px;
	//border: 1px solid #295a85;
	color: #fff;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active{
	background: #cc66ff;
}
::v-deep .el-pagination__editor.el-input .el-input__inner{
	background: transparent;
	//border: 1px solid #295a85;
	color: #fff;
}
::v-deep .el-pagination__total, ::v-deep .el-pagination__jump{
	color: #fff;
}

.dialog-content {
	background: -webkit-linear-gradient(left,  rgb(145, 217, 246) 0%,#db6ff3 100%);
}

.fade-enter-active, .fade-leave-active {
	transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
	opacity: 0;
}
.fade-enter-to, .fade-leave {
	opacity: 1;
}
.icon-container {
	display: flex;
	align-items: center;
	justify-content: space-around;
}

.custom-btn {
	width: 130px;
	height: 40px;
	color: #fff;
	border-radius: 5px;
	padding: 10px 10px;
	//margin: 0 10px;
	font-family: 'Lato', sans-serif;
	font-weight: 500;
	background: transparent;
	cursor: pointer;
	transition: all 0.3s ease;
	position: relative;
	display: inline-block;
	box-shadow:inset 2px 2px 2px 0px rgba(255,255,255,.5), 7px 7px 20px 0px rgba(0,0,0,.1),
	4px 4px 5px 0px rgba(0,0,0,.1);
	outline: none;

}

.btn-9 {
	border: none;
	transition: all 0.3s ease;
	overflow: hidden;

	&:after {
		position: absolute;
		content: " ";
		z-index: -1;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: #1fd1f9;
		background-image: linear-gradient(315deg, #1fd1f9 0%, #b621fe 74%);
		transition: all 0.3s ease;
	}
	&:hover {
		background: transparent;
		box-shadow:  4px 4px 6px 0 rgba(255,255,255,.5),
		-4px -4px 6px 0 rgba(116, 125, 136, .2),
		inset -4px -4px 6px 0 rgba(255,255,255,.5),
		inset 4px 4px 6px 0 rgba(116, 125, 136, .3);
		color: #fff;
	}
	&:hover:after {
		-webkit-transform: scale(2) rotate(180deg);
		transform: scale(2) rotate(180deg);
		box-shadow:  4px 4px 6px 0 rgba(255,255,255,.5),
		-4px -4px 6px 0 rgba(116, 125, 136, .2),
		inset -4px -4px 6px 0 rgba(255,255,255,.5),
		inset 4px 4px 6px 0 rgba(116, 125, 136, .3);
	}
}

.btn-12 {
	position: relative;
	right: 20px;
	bottom: 20px;
	border:none;
	box-shadow: none;
	width: 130px;
	height: 40px;
	line-height: 42px;
	-webkit-perspective: 230px;
	perspective: 230px;

	& span {
		background: rgb(0,172,238);
		background: linear-gradient(0deg, rgba(0,172,238,1) 0%, rgba(2,126,251,1) 100%);
		display: block;
		position: absolute;
		width: 130px;
		height: 40px;
		box-shadow:inset 2px 2px 2px 0px rgba(255,255,255,.5),
		7px 7px 20px 0px rgba(0,0,0,.1),
		4px 4px 5px 0px rgba(0,0,0,.1);
		border-radius: 5px;
		margin:0;
		text-align: center;
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		box-sizing: border-box;
		-webkit-transition: all .3s;
		transition: all .3s;
	}
	& span:nth-child(1) {
		box-shadow:
				-7px -7px 20px 0px #fff9,
				-4px -4px 5px 0px #fff9,
				7px 7px 20px 0px #0002,
				4px 4px 5px 0px #0001;
		-webkit-transform: rotateX(90deg);
		-moz-transform: rotateX(90deg);
		transform: rotateX(90deg);
		-webkit-transform-origin: 50% 50% -20px;
		-moz-transform-origin: 50% 50% -20px;
		transform-origin: 50% 50% -20px;
	}
	& span:nth-child(2) {
		-webkit-transform: rotateX(0deg);
		-moz-transform: rotateX(0deg);
		transform: rotateX(0deg);
		-webkit-transform-origin: 50% 50% -20px;
		-moz-transform-origin: 50% 50% -20px;
		transform-origin: 50% 50% -20px;
	}
	&:hover span:nth-child(1) {
		box-shadow:inset 2px 2px 2px 0px rgba(255,255,255,.5),
		7px 7px 20px 0px rgba(0,0,0,.1),
		4px 4px 5px 0px rgba(0,0,0,.1);
		-webkit-transform: rotateX(0deg);
		-moz-transform: rotateX(0deg);
		transform: rotateX(0deg);
	}
	&:hover span:nth-child(2) {
		box-shadow:inset 2px 2px 2px 0px rgba(255,255,255,.5),
		7px 7px 20px 0px rgba(0,0,0,.1),
		4px 4px 5px 0px rgba(0,0,0,.1);
		color: transparent;
		-webkit-transform: rotateX(-90deg);
		-moz-transform: rotateX(-90deg);
		transform: rotateX(-90deg);
	}
}

</style>

